import { findAnimationByTripoPreset } from 'Pods/ThreeDStudio/Services/Constants/animations'
import { getAssetByTypeAndSource } from 'Pods/ThreeDStudio/Shared/Utils/getAssetByTypeAndSource'
import {
  ACTION,
  DEFAULT_ANIMATE_SETTINGS,
  PROVIDER,
  VIEWER_SIDEBAR_TAB,
} from 'Pods/ThreeDStudio/Store/constants'

import { getModelFormatOutput } from './getModelFormatOutput'

/**
 * Builds the ThreeDStudio store patch for a Tripo3D animation-default run.
 * Maps the run's Tripo3D preset back to the local library slug the Animate tab
 * selects on, and opens the viewer sidebar on the ANIMATE tab.
 *
 * @param {Object} openedModel - Run object from the library
 * @returns {Object} parsedData - ThreeDStudio store patch
 */
export const parseTripo3dAnimationDefaultData = (openedModel) => {
  const {
    id: sessionId,
    modelFormatOutput: rawModelFormatOutput,
    generatorSessionId,
    outputAssets,
  } = openedModel
  const { animation } = openedModel.providerRunAttributes || {}
  const { id: animationId } = findAnimationByTripoPreset(animation) || {}
  const {
    assetId: inputThreeD,
    fileUrl: inputThreeDUrl,
  } = getAssetByTypeAndSource(outputAssets, '3d_model', 'ai_generated')
  const modelFormatOutput = getModelFormatOutput({
    modelFormatOutput: rawModelFormatOutput,
    modelUrl: inputThreeDUrl,
  })

  const schema = { enhancedAction: ACTION.ANIMATION, enhancedProvider: PROVIDER.TRIPO3D }
  const generation = { sessionId, generatorSessionId }
  const viewer = { fileFormat: modelFormatOutput, inputThreeD }
  const animateSettings = {
    animationId: animationId ?? DEFAULT_ANIMATE_SETTINGS.animationId,
  }
  const ui = {
    isModelSettingsOpen: false,
    isViewerSidebarOpen: true,
    activeViewerSidebarTab: VIEWER_SIDEBAR_TAB.ANIMATE,
  }

  return {
    openedModel,
    schema,
    animateSettings,
    ui,
    generation,
    viewer,
  }
}
